module.exports = __webpack_public_path__ + "img/imprint-external-scan.94347f18.png";